import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Steps = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0287 2.53959C11.6328 2.20401 12.3672 2.20401 12.9713 2.53959L19.9713 6.42848C20.6062 6.78122 21 7.45046 21 8.17679V15.8232C21 16.5495 20.6062 17.2188 19.9713 17.5715L12.9713 21.4604C12.3672 21.796 11.6328 21.796 11.0287 21.4604L4.02871 17.5715C3.39378 17.2188 3 16.5495 3 15.8232V8.17679C3 7.45046 3.39378 6.78122 4.02871 6.42848L11.0287 2.53959ZM18.0034 7.62313L12 4.2879L5.99668 7.62308L12.0001 11L18.0034 7.62313ZM5 9.35714L5 15.8232L11.0001 19.1565V12.7322L5 9.35714ZM13.0001 19.1565L19 15.8232V9.35725L13.0001 12.7322V19.1565Z"
      fill="currentColor"
    />
  </Icon>
));

export default Steps;
